import React from 'react'
import PropTypes from 'prop-types'
import { Carousel } from 'react-bootstrap'
import styled from 'styled-components'

const StyledCarousel = styled.div`
  width: 261px;
  height: 346px !important;
  .carousel-indicators [data-bs-target] {
    height: 5px;
  }
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    width: 31.42px;
    height: 32px;
  }
`

const ImageCarousel = ({ images }) => {
  const hideControls = images.length > 1
  return (
    <StyledCarousel>
      <Carousel
        interval={null}
        indicators={hideControls}
        controls={hideControls}
        keyboard={hideControls}
        touch={hideControls}
        nextLabel="Next"
        prevLabel="Previous"
        aria-live="polite"
      >
        {images.map((image, idx) => (
          <Carousel.Item key={`photoPOD-image-${idx}`}>
            <img
              className="d-block w-100"
              src={image}
              alt={`item ${idx + 1} of ${images.length}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </StyledCarousel>
  )
}

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
}

ImageCarousel.defaultProps = {
  images: [],
}

export default ImageCarousel
